module.exports = __webpack_public_path__ + "img/badge-most-proposals-keyvue-green.b449feff.png";